import { AxiosError } from "axios";

export class ConflictError extends Error {
  constructor(error: AxiosError) {
    super(error.message);
    this.message = error.response?.data;
    this.name = "ConflictError";
  }
}
